export default __webpack_public_path__ + "static/media/adler.7110674c.png";